
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[url_slug]",
      function () {
        return require("private-next-pages/jobs/[url_slug]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/[url_slug]"])
      });
    }
  